/**
 * Clasificación efectiva de un gasto: puntual vs suscripción.
 * - clasificacion_manual 0 = forzar puntual
 * - clasificacion_manual 1 = forzar suscripción
 * - null/undefined = automático: suscripción solo si viene del script (suscripcion_id)
 */
export function esSuscripcionEfectivo(g) {
  if (g == null) return false;
  const manual = g.clasificacion_manual;
  if (manual === 0 || manual === '0') return false;
  if (manual === 1 || manual === '1') return true;
  return !!g.suscripcion_id;
}

/**
 * Clasificación para UI (lista de gastos, resumen desglosado): suscripción si
 * override manual a suscripción, gasto del script (suscripcion_id), categoría
 * tipo suscripción, o gasto desde pago planificado (origen_planificado).
 * "Puntual (fijar)" solo aplica si la categoría no es de suscripción y no hay
 * origen planificado; así NordVPN en Suscripciones Premium no queda en blanco
 * por un clasificacion_manual=0 erróneo.
 */
export function esSuscripcionGastoUi(g) {
  if (g == null) return false;
  const manual = g.clasificacion_manual;
  if (manual === 1 || manual === '1') return true;
  if (g.suscripcion_id) return true;
  const cat = (g.categoria_nombre || '').toLowerCase();
  if (cat.includes('suscripci')) return true;
  if (g.origen_planificado === 1 || g.origen_planificado === '1') return true;
  if (manual === 0 || manual === '0') return false;
  return false;
}
